import backend from './backend';
import googleDoc from './googleDoc';

const clients = {
    default: backend,
    googleDoc,
};

export default clients;
